import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getActiveFeatures } from '../utils.js';
import MarLandingOld from './MarLandingOld';
import MarLandingNew from './MarLandingNew';
var MAR_LANDING_FLAG = "MAR_LANDING_REFACTOR";
// Page level router injected props need to be passed down
// To avoid flickering / flashes of cards / expensive re-renders
// Do not render the cards until these dependencies / checks have resolved
// The feature flags must be available AND at least one brand must be resolved
var MarLanding = function (props) {
  var _a = useSelector(function (store) {
      return {
        layout: store,
        translations: store.translations,
        features: store.features,
        isPennymac: store.isPennymac,
        isCobranded: store.isCobranded,
        isPrivateLabel: store.isPrivateLabel
      };
    }),
    layout = _a.layout,
    translations = _a.translations,
    features = _a.features,
    isPennymac = _a.isPennymac,
    isCobranded = _a.isCobranded,
    isPrivateLabel = _a.isPrivateLabel;
  var isAnyBrandResolved = useMemo(function () {
    return [isPennymac, isCobranded, isPrivateLabel].some(function (value) {
      return value === true;
    });
  }, [isPennymac, isCobranded, isPrivateLabel]);
  var shouldShowHomeCards = !!(features === null || features === void 0 ? void 0 : features.length) && isAnyBrandResolved;
  if (getActiveFeatures(features, MAR_LANDING_FLAG, false)) return /*#__PURE__*/React.createElement(MarLandingNew, __assign({
    layout: layout,
    translations: translations,
    showHomeCards: shouldShowHomeCards
  }, props));
  return /*#__PURE__*/React.createElement(MarLandingOld, __assign({
    showHomeCards: shouldShowHomeCards
  }, props));
};
export default MarLanding;